import {RouterStore} from "mobx-react-router"

var singleton = new RouterStore()
export default singleton
